import {Injectable} from '@angular/core';
import {BehaviorSubject, catchError, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {AuthService} from "../auth.service";

export interface Quota {
  User: string;
  Quota?: string;
  Quota_left: string | number;
}

export interface UserInfo {
  id: number,
  display: string,
  has_usable_password: boolean,
  email: string,
  username: string,
  preferred_username: string,
  first_name: string,
  last_name: string,
  full_name: string,
  num_credits: number,
  sum_credits: number,
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  readonly BASE_API_URL = environment.API.BASE_URL
  public quota = new BehaviorSubject<Quota | null>(null);
  user = this.authService.getUser()

  constructor(private http: HttpClient,
              private authService: AuthService) {
    this.loadQuota();
  }

  loadUser(): void {
    // Could trigger refresh of user data here
  }

  // We need to be able to trigger this directly
  loadQuota(): void {
      // TODO(ML): There is probably a better way to deal with the 429 here. Rework this.
    this.http.get<Quota>(`${this.BASE_API_URL}/user/quota`, {withCredentials: true}).pipe(
        catchError((err: HttpErrorResponse) => {
              if (err.status === 429) {
                  this.quota.next(err.error as Quota)
              }
              return throwError(() => err);
            })
        )
        .subscribe((quota) => {
            this.quota.next(quota)
        });
  }

  refresh(): void {
    this.loadQuota();
  }

}